module.exports = __webpack_public_path__ + "img/IMG_0459_L_Wood_MockedUp.bc55b676.jpg";